import Portal from '@ixigo/iui/Portal';
import { LazyUi } from '@ixigo/ui-kit/LazyUi';
import { useRouterState } from '@tanstack/react-router';
import LinearProgressBar from './LinearProgressBar';

export default function LinearProgress() {
	const isPending = useRouterState({
		select: (state) => {
			return state.status === 'pending';
		},
	});

	return <LazyUi loading={isPending} fallback={<Fallback />} />;
}

function Fallback() {
	return (
		<Portal>
			<LinearProgressBar className="fixed top-0 w-full h-1 z-[1301] text-brand bg-brand-subtle" />
		</Portal>
	);
}
